/**
 * Supported language codes for multilingual content.
 * Mirrors constants from node-shared/src/constants/index.ts — keep in sync.
 */
export type SupportedLanguage = {
    code: string;
    label: string;
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
    { code: 'en-US', label: 'English' },
    { code: 'es-CR', label: 'Spanish' },
];

export const DEFAULT_LANGUAGE_CODE = 'en-US';
